import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {SecurityGroupsContext} from '../../securityGroupComparer.js';

const SecGroupComparison = (props) => {

  const comparison = useContext(SecurityGroupsContext);

  const {groupOneInRules, groupTwoInRules, groupTwoOutRules, groupOneOutRules} = comparison;

  let inProtocols = [];
  let outProtocols = [];

  if (groupOneInRules && groupTwoInRules) {
    inProtocols = [...groupOneInRules, ...groupTwoInRules].reduce((acc, rule) => {
      if (!acc.includes(rule.protocol)) acc.push(rule.protocol);
      return acc;
    }, []);
  };

  if (groupOneOutRules && groupTwoOutRules) {
    outProtocols = [...groupOneOutRules, ...groupTwoOutRules].reduce((acc, rule) => {
      if (!acc.includes(rule.protocol)) acc.push(rule.protocol);
      return acc;
    }, []);
  };

  const maxRules = {
    in: {},
    out: {}
  };

  inProtocols.forEach(protocol => {
    maxRules.in[protocol] = Math.max();
  });

  return (
    <div className="SecGroupComparisonPage">
      <h1>In Rules</h1>
      {inProtocols.map(protocol => {
        return (
          <div className="protocolContainer" key={protocol}>
            <div className="ruleListContainer">
              {/* {groupOneInRules.map(rule => {
                return <div key={rule.id}>{JSON.stringify(rule)}</div>;
              })} */}
              {groupOneInRules.filter(ele => ele.protocol === protocol).sort((a, b) => {
                if (!a.match && !b.match) {
                  return a.id - b.id;
                } else if (a.match && b.match) {
                  return a.match - b.match;
                } else if (a.match) return -1;
                else return 1;
              }).map(rule => {
                return (
                  <div className={`ruleRow${rule.match ? ' ruleRowMatch' : ''}`} key={rule.id}>
                    <div>{rule.protocol}</div>
                    <div>{rule.ipRange}</div>
                    <div>{rule.portRange}</div>
                  </div>
                );
              })}
            </div>
            <div className="ruleListContainer">
              {groupTwoInRules.filter(ele => ele.protocol === protocol).sort((a, b) => {
                if (!a.match && !b.match) {
                  return a.id - b.id;
                } else if (a.match && b.match) {
                  return a.id - b.id;
                } else if (a.match) return -1;
                else return 1;
              }).map(rule => {
                return (
                  <div className={`ruleRow${rule.match ? ' ruleRowMatch' : ''}`} key={rule.id}>
                    <div>{rule.protocol}</div>
                    <div>{rule.ipRange}</div>
                    <div>{rule.portRange}</div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
      <br/>
      <h1>Out Rules</h1>
      {outProtocols.map(protocol => {
        return (
          <div className="protocolContainer" key={protocol}>
            <div className="ruleListContainer">
              {groupOneOutRules.filter(ele => ele.protocol === protocol).sort((a, b) => {
                if (!a.match && !b.match) {
                  return a.id - b.id;
                } else if (a.match && b.match) {
                  return a.match - b.match;
                } else if (a.match) return -1;
                else return 1;
              }).map(rule => {
                return (
                  <div className={`ruleRow${rule.match ? ' ruleRowMatch' : ''}`} key={rule.id}>
                    <div>{rule.protocol}</div>
                    <div>{rule.ipRange}</div>
                    <div>{rule.portRange}</div>
                  </div>
                );
              })}
            </div>
            <div className="ruleListContainer">
              {groupTwoOutRules.filter(ele => ele.protocol === protocol).sort((a, b) => {
                if (!a.match && !b.match) {
                  return a.id - b.id;
                } else if (a.match && b.match) {
                  return a.id - b.id;
                } else if (a.match) return -1;
                else return 1;
              }).map(rule => {
                return (
                  <div className={`ruleRow${rule.match ? ' ruleRowMatch' : ''}`} key={rule.id}>
                    <div>{rule.protocol}</div>
                    <div>{rule.ipRange}</div>
                    <div>{rule.portRange}</div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );

};

SecGroupComparison.propTypes = {

};

export default SecGroupComparison;


// WEBPACK FOOTER //
// ./src/components/content/securityGroupComparer/secGroupContainer/secGroupComparison/secGroupComparison.js